import type {Component, Editor} from 'grapesjs';
import {updateTableColumns, updateTableRows} from '@EmailMakerReact/lib/email-maker-table-library';
import type {StepButtonsDescriptor} from './step-buttons-control.types';

export const rowsStepDescriptor: StepButtonsDescriptor = {
  property: 'pmw-rows',
  labelKey: 'pmwjs_rows',
  unit: '',
  min: 1,
  max: 20,
  step: 1,
  defaults: 1,
  onValueChange(_component: Component, editor: Editor, value: number): void {
    updateTableRows(editor, value);
  },
};

export const columnsStepDescriptor: StepButtonsDescriptor = {
  property: 'pmw-columns',
  labelKey: 'pmwjs_columns',
  unit: '',
  min: 1,
  max: 4,
  step: 1,
  defaults: 1,
  onValueChange(_component: Component, editor: Editor, value: number): void {
    updateTableColumns(editor, value);
  },
};
